(function() {
  var DialogController,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.ProfileController = (function(superClass) {
    extend(ProfileController, superClass);

    function ProfileController(state, transitions, modalInstance, ProfileData) {
      var jsr;
      this.state = state;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      ProfileController.__super__.constructor.call(this, this.state, this.transitions, this.modalInstance);
      this.scope.title = 'Profile:';
      this.scope.profile = {
        user_name: null,
        phone: null,
        email: null,
        address: {
          addr1: null,
          addr2: null,
          city: null,
          zip: null,
          state: null
        }
      };
      jsr = ProfileData.data;
      if (jsr.status.type === 'success') {
        this.scope.title = "Profile: " + jsr.data.user_name;
        $.extend(this.scope.profile, jsr.data);
      }
    }

    return ProfileController;

  })(DialogController);

}).call(this);
